import React, { useCallback } from "react"
import { Navigate, useNavigate } from "react-router-dom"
import { useConfig } from "../../hooks/useConfig"
import { useParticipant } from "../../hooks/useParticipant"
import { useBoothSession } from "../../hooks/useBoothSession"
import WrapUpView from "../views/WrapUpView"

function WrapUpPage() {
  const navigate = useNavigate()

  const config = useConfig()
  const { participant } = useParticipant(config.presetCode)
  const { rawImage, aiProcessedImage, compositeImage, clearImages } = useBoothSession()

  const handleFinish = useCallback(
    (uploadCode: string) => {
      navigate(`/${config.presetCode}/pic/${uploadCode}/new`)
    },
    [config, navigate],
  )

  const resetBooth = useCallback(() => {
    clearImages()
    navigate(`/${config.presetCode}/camera`)
  }, [config, navigate, clearImages])

  // Redirect to edit if we have an image but no composite, otherwise back to camera
  if (!rawImage || !compositeImage) {
    if (!compositeImage && (rawImage || aiProcessedImage)) {
      return <Navigate to={`/${config.presetCode}/edit`} replace />
    }
    return <Navigate to={`/${config.presetCode}/camera`} replace />
  }

  return (
    <WrapUpView
      rawFrame={rawImage}
      compositeImage={compositeImage}
      participant={participant}
      finish={handleFinish}
      reset={resetBooth}
    />
  )
}

export default WrapUpPage
